import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HorizontalFilterFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M13.5 16.25C14.1904 16.25 14.75 16.8096 14.75 17.5V20.5C14.75 21.1904 14.1904 21.75 13.5 21.75H11.5C10.8096 21.75 10.25 21.1904 10.25 20.5V20H3.5C2.94771 20 2.5 19.5523 2.5 19C2.5 18.4477 2.94771 18 3.5 18H10.25V17.5C10.25 16.8096 10.8096 16.25 11.5 16.25H13.5ZM20.5 18C21.0523 18 21.5 18.4477 21.5 19C21.5 19.5523 21.0523 20 20.5 20H16.5C15.9477 20 15.5 19.5523 15.5 19C15.5 18.4477 15.9477 18 16.5 18H20.5ZM10.5 9.25C11.1904 9.25 11.75 9.80964 11.75 10.5V11H20.5C21.0523 11 21.5 11.4477 21.5 12C21.5 12.5523 21.0523 13 20.5 13H11.75V13.5C11.75 14.1904 11.1904 14.75 10.5 14.75H8.5C7.80964 14.75 7.25 14.1904 7.25 13.5V10.5C7.25 9.80964 7.80964 9.25 8.5 9.25H10.5ZM5.5 11C6.05228 11 6.5 11.4477 6.5 12C6.5 12.5523 6.05228 13 5.5 13H3.5C2.94772 13 2.5 12.5523 2.5 12C2.5 11.4477 2.94772 11 3.5 11H5.5ZM15.5 2.25C16.1904 2.25 16.75 2.80964 16.75 3.5V6.5C16.75 7.19036 16.1904 7.75 15.5 7.75H13.5C12.8096 7.75 12.25 7.19036 12.25 6.5V6H3.5C2.94771 6 2.5 5.55228 2.5 5C2.5 4.44772 2.94771 4 3.5 4H12.25V3.5C12.25 2.80964 12.8096 2.25 13.5 2.25H15.5ZM20.5 4C21.0523 4 21.5 4.44772 21.5 5C21.5 5.55228 21.0523 6 20.5 6H18.5C17.9477 6 17.5 5.55228 17.5 5C17.5 4.44772 17.9477 4 18.5 4H20.5Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HorizontalFilterFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HorizontalFilterFilledIcon;
